import { HttpErrorResponse } from '@angular/common/http';
import { NotificationServiceHM } from 'src/app/menu/notification-item/notification-item.service';

export function getHttpStatus(error: unknown): number | undefined {
  if (error instanceof HttpErrorResponse) {
    return error.status;
  }
  const status = (error as { status?: unknown })?.status;
  return typeof status === 'number' ? status : undefined;
}

export function isServiceUnavailable(error: unknown): boolean {
  return getHttpStatus(error) === 503;
}

/** Mensagem `message` retornada pelo backend, ou string vazia se ausente. */
export function getBackendErrorMessage(error: unknown): string {
  const body = error instanceof HttpErrorResponse ? error.error : (error as { error?: unknown })?.error;
  const message = (body as { message?: unknown })?.message;
  return typeof message === 'string' ? message.trim() : '';
}

/**
 * Código do motivo que a API manda em alguns erros (ex.: `repository_access_denied` nos 403
 * de acesso a um review). Serve para escolher o que mostrar sem interpretar a mensagem.
 */
export function getBackendErrorCode(error: unknown): string {
  const body = error instanceof HttpErrorResponse ? error.error : (error as { error?: unknown })?.error;
  const code = (body as { code?: unknown })?.code;
  return typeof code === 'string' ? code.trim() : '';
}

/**
 * Mensagem a exibir num erro: SEMPRE a `message` do backend quando vier; o
 * `fallback` (texto do front) só é usado quando o backend não envia mensagem
 * (ex.: erro de rede, 500 sem corpo). Nunca substitui a mensagem da API.
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  return getBackendErrorMessage(error) || fallback;
}

/**
 * Exibe a mensagem do backend (503) como toast amigável. Usa um fallback genérico
 * curto apenas quando o backend não envia `message`.
 */
export function showServiceUnavailableToast(notification: NotificationServiceHM, error: unknown): void {
  const message = getBackendErrorMessage(error) || 'Serviço temporariamente indisponível. Tente novamente mais tarde.';
  notification.showToast(message, 'warning', { durationMs: 8000 });
}
